import { CommonConstant } from '../../../app.constants';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { NumberUtils } from '../../../utils/number.utils';
var BestPerformingInfluencerComponent = /** @class */ (function () {
    function BestPerformingInfluencerComponent(pdfService, router, userService) {
        this.pdfService = pdfService;
        this.router = router;
        this.userService = userService;
        this.bestPerformingInfluencers = [];
    }
    BestPerformingInfluencerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.bestPerformingInfluencers.length === 0) {
            this.pdfService.incrementNumberReportReady(BestPerformingInfluencerComponent.COMPONENT_NAME);
            return;
        }
        this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
            if (data.component === BestPerformingInfluencerComponent.COMPONENT_NAME
                && data.currentCounter === _this.bestPerformingInfluencers.length) {
                console.log('all images of BestPerformingInfluencerComponent are loaded');
                _this.pdfService.incrementNumberReportReady(BestPerformingInfluencerComponent.COMPONENT_NAME);
            }
        });
    };
    Object.defineProperty(BestPerformingInfluencerComponent.prototype, "topThreePerformingInfluencer", {
        get: function () {
            // Not handle for empty list
            if (this.bestPerformingInfluencers.length === 0) {
                return [];
            }
            return this.bestPerformingInfluencers.slice(0, 3);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BestPerformingInfluencerComponent.prototype, "remaningInfluencerExcludeTopThree", {
        get: function () {
            // Not handle for empty list
            if (this.bestPerformingInfluencers.length === 0) {
                return [];
            }
            var numberOfInfluencer = this.bestPerformingInfluencers.length;
            return this.bestPerformingInfluencers.slice(3, numberOfInfluencer);
        },
        enumerable: true,
        configurable: true
    });
    BestPerformingInfluencerComponent.prototype.findCountryCode = function (influencer) {
        return influencer.country ? influencer.country.code : CommonConstant.INTERNATION_COUNTRY_CODE;
    };
    BestPerformingInfluencerComponent.prototype.callbackImageLoaded = function () {
        this.pdfService.updateNumberImageLoaded(BestPerformingInfluencerComponent.COMPONENT_NAME);
    };
    Object.defineProperty(BestPerformingInfluencerComponent.prototype, "isExportingReport", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    BestPerformingInfluencerComponent.prototype.formattedMentionCount = function (mentionCount) {
        if (mentionCount <= 0) {
            return '-';
        }
        return NumberUtils.normalizeNumberToString(mentionCount);
    };
    BestPerformingInfluencerComponent.prototype.openInfluencerDetails = function (influencerId) {
        return this.router.navigate(["/influencer/" + influencerId + "/overview"], {
            queryParams: {
                activeAccount: this.userService.getCompanyId()
            }
        });
    };
    BestPerformingInfluencerComponent.COMPONENT_NAME = 'BestPerformingInfluencerComponent';
    return BestPerformingInfluencerComponent;
}());
export { BestPerformingInfluencerComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/best-performing-influencer/best-performing-influencer.component.ts.pre-build-optimizer.js